// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import EditVariant from '../components/EditVariant';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({}, dispatch)
)(EditVariant);
